import axios from 'axios'
import config from '../config/app'

export default {
  getByCompany (userId, companyId) {
    return this.get({status: 'active', company_id: companyId})
  },
  getByUser (userId) {
    return this.get({user_id: userId, status: 'active'})
  },
  // For impact page showing credits
  getByCompanyCredit (userId, companyId) {
    return this.get({company_id: companyId})
  },
  getByUserCredit (userId) {
    return this.get({user_id: userId})
  },
  get (params, additional) {
    if (additional !== null && additional !== undefined) {
      params.additional = additional.join(',')
    }
    let stringParams = Object.keys(params).filter((i) => { return params[i] !== '' && params[i] !== null }).map((k) => {
      return params[k] !== null && params[k] !== undefined && typeof params[k] === 'object' ? Object.keys(params[k]).map((m) => { return encodeURIComponent(k) + '[' + encodeURIComponent(m) + ']' + '=' + encodeURIComponent(params[k][m]) }).join('&') : encodeURIComponent(k) + '=' + encodeURIComponent(params[k])
    }).join('&')
    let url = config.server + '/credit?' + stringParams

    return new Promise((resolve, reject) => {
      axios.get(url).then((response) => {
        resolve(response.data)
      }, (error) => {
        reject(error)
      })
    })
  },
  stat () {
    return new Promise((resolve, reject) => {
      axios.get(config.server + '/credit/stat').then((response) => {
        resolve(response.data)
      }, (error) => {
        reject(error)
      })
    })
  },
  create (data) {
    return new Promise((resolve, reject) => {
      axios.post(config.server + '/credit', data).then((response) => {
        resolve(response.data)
      }, (error) => {
        reject(error)
      })
    })
  },
  getById (id) {
    return new Promise((resolve, reject) => {
      axios.get(config.server + '/credit/' + id).then((response) => {
        resolve(response.data)
      }, (error) => {
        reject(error)
      })
    })
  },
  search (params) {
    let str = Object.keys(params).map((key) => {
      return key + '=' + params[key]
    }).join('&')
    return new Promise((resolve, reject) => {
      axios.get(config.server + '/credit/search?' + str).then((response) => {
        resolve(response.data)
      }, (error) => {
        reject(error)
      })
    })
  },
  getRedemptionById (id) {
    return new Promise((resolve, reject) => {
      axios.get(config.server + '/credit/' + id + '/redemption').then((response) => {
        resolve(response.data)
      }, (error) => {
        reject(error)
      })
    })
  },
  removeCredits (id) {
    return new Promise((resolve, reject) => {
      axios.post(config.server + '/credit/remove-credits', {id: id}).then((response) => {
        resolve(response.data)
      }, (error) => {
        reject(error)
      })
    })
  }
}



// WEBPACK FOOTER //
// ./src/api/credit.js